module.exports = __webpack_public_path__ + "static/img/2-20-错发换货建单.ae5cc00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/ppt/2-20-错发换货建单.png
// module id = 1356
// module chunks = 0